module.exports = __webpack_public_path__ + "static/media/_BID5492.1cb5667e.png";